import AppData from '../../Model/MerchantAppData';
import BaseFirebaseRepository from './BaseFirebaseRepository';

const instances = {}
const defaultInstanceKey = Math.random()
export default class BillRepository extends BaseFirebaseRepository {
    /**
     * @param {*} app 
     * @return {BillRepository}
     */
    static getInstance(app) {
        if (app == null) {
            // By default, use instance created from main App
            app = AppData.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new BillRepository(app)
        }
        return instances[app]
    }
    constructor(app) {
        super(app)
    }

    getApiBaseUrl = (id) => {
        if (id) {
            return `/merchant/api/bill/${id}`
        }
        return "/merchant/api/bill"
    }
    getSingleRef = () => {
        return firebase.database().ref(firebase_path + '/bills/')
        .orderByChild("id")
    }
    getBaseObject = () => {
        return {}
    }
}